export const selectMachinery = state => state.machine.machinery

export const selectCurrentMachine = state => state.machine.currentMachine
